"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalDotsCircle = void 0;
var React = __importStar(require("react"));
var VerticalDotsCircle = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("path", {
    d: "M24,5c10.5,0,19,8.5,19,19s-8.5,19-19,19S5,34.5,5,24S13.5,5,24,5 M24,1C11.3,1,1,11.3,1,24s10.3,23,23,23s23-10.3,23-23\n  S36.7,1,24,1L24,1z M24,21c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S25.7,21,24,21z M24,32c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3\n  S25.7,32,24,32z M24,10c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S25.7,10,24,10z"
  }));
};
exports.VerticalDotsCircle = VerticalDotsCircle;